module.exports = __webpack_public_path__ + "img/pen-active.bc56bb8d.svg";